<div class="approvals_section">
    <div class="row">
        <div class="col-md-12">
            <app-approval-request [pendingApprovalList]="pendingApprovalList" *ngIf="pendingApprovalList"
                (updateList)="updateList($event)"></app-approval-request>
            <!-- <div class=" col-md-12 no-type d-flex align-items-center justify-content-center w-100"
                *ngIf="pendingApprovalList.length <= 0">
                <h3>No data available to display here.Please come back later</h3>
            </div> -->
        </div>

        <div class="col-md-12">
            <app-completed-approvals [completedApprovalList]="completedApprovalList"
                *ngIf="completedApprovalList"></app-completed-approvals>

        </div>


    </div>
</div>